import apiClient from "./apiClient";

export function listRolesRequest(params = {}) {
  return apiClient.get("/roles", { params });
}

export function listAllRolesRequest() {
  return apiClient.get("/roles/all");
}

export function getRoleRequest(roleId) {
  return apiClient.get(`/roles/${roleId}`);
}

export function createRoleRequest(payload) {
  return apiClient.post("/roles", payload);
}

export function updateRoleRequest(roleId, payload) {
  return apiClient.patch(`/roles/${roleId}`, payload);
}

export function deleteRoleRequest(roleId) {
  return apiClient.delete(`/roles/${roleId}`);
}
